import { createSlice } from "@reduxjs/toolkit";
import { Tusers, initialUsers } from "../type/users";

export interface utlsSList {
    registerForm: Tusers,
    users: Tusers,
    loadingStatus: Boolean
}

const initialState: utlsSList = {
    registerForm: initialUsers,
    users: initialUsers,
    loadingStatus: false
}

const utlsSlice = createSlice({
    name: "utls",
    initialState,
    reducers: {
        setRegisterForm: (state, action) => {
            state.registerForm = action.payload
        },
        setUser: (state, action) => {
            state.users = action.payload
        },
        setLoadingStatus: (state, action) => {
            state.loadingStatus = action.payload
        }
    }
});

export const { setRegisterForm, setUser, setLoadingStatus } = utlsSlice.actions;
export default utlsSlice.reducer;